const {BASE_URL} = require('./client');

const GET_PAYMENTS = BASE_URL + '/api/payments/get';
module.exports = {
    GET_PAYMENTS
}